import type { AxiosInstance } from 'axios';
import authService from './auth.service';

/**
 * The one acceptance after sign-in (owner, 2026-10-28).
 *
 *   POST /api/v1/legal-documents/accept
 *
 * Carries the version of each document the person ticked and nothing for one they do not owe;
 * the server records both in one transaction, each acceptance on its own row, and refuses (422)
 * a version that is no longer the one in force.
 */
export interface LegalDocumentsAcceptance {
  terms_version?: number;
  privacy_notice_version?: number;
}

export interface LegalDocumentsAccepted {
  terms_accepted: boolean;
  privacy_notice_accepted: boolean;
}

class LegalDocumentsService {
  private get api(): AxiosInstance {
    return authService.getApi();
  }

  async accept(acceptance: LegalDocumentsAcceptance): Promise<LegalDocumentsAccepted> {
    const res = await this.api.post<LegalDocumentsAccepted>(
      '/api/v1/legal-documents/accept',
      acceptance,
    );
    return res.data;
  }
}

export default new LegalDocumentsService();
